<template>
  <transition name="slide-fade">
    <v-container fluid>
      <v-layout wrap class="justify-center">
        <v-flex xs12 md4 sm8>
          <h3 class="text-center">Change Password</h3>
          <v-card elevation="24">
            <v-card-text>
              <form @submit.prevent="changePassword">
                <v-text-field label="Email Address" type="email" required v-model="user.email" name="Email" :error-messages="errors.email" hint="You will be required to verify your email again after successful password change"></v-text-field>
                <v-text-field label="Current Password" type="password" required v-model="user.old_password" name="Password" :error-messages="errors.old_password"></v-text-field>
                <v-divider></v-divider>
                <v-text-field label="New Password" required v-model="user.password" name="New Password" :type="e1 ? 'text' : 'password'" :error-messages="errors.password" :append-icon="e1 ? 'mdi-eye-off' : 'mdi-eye'" @click:append="e1 = !e1"></v-text-field>
                <v-text-field label="Confirm Password" required v-model="user.password_confirmation" name="New Password" :type="e1 ? 'text' : 'password'" :append-icon="e1 ? 'mdi-eye-off' : 'mdi-eye'" @click:append="e1 = !e1"></v-text-field>
                <v-btn small type="submit" color="primary" class="pull-right" :loading="saving">Submit</v-btn>
                <br>
                <span class="success--text" v-html="message"></span>
              </form>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </transition>
</template>

<script>
  import layout from '@/Layouts/Guest'

  export default {
    name: 'ChangeUserPassword',
    layout,
    props: [
      'errors',
      'message'
    ],
    components: {},
    metaInfo () {
      return {
        title: 'Change Password',
        titleTemplate: '%s | ' + this.$title,
      }
    },
    data () {
      return {
        user: {
          email: '',
          password: '',
          old_password: ''
        },
        saving: false,
        e1: false
      }
    },
    methods: {
      changePassword () {
        this.$inertia.put('/user/password', this.user, {
          preserveScroll: true,
          preserveState: true,
          onBefore: () => this.saving = true,
          onFinish: () => this.saving = false
        })
      },
    },
    created () {
      // this.somemethod()
    },
    computed: {},
    watch: {
      'e1': function (val) {
        if (val) {
          let vm = this
          setTimeout(() => {
            vm.e1 = false
          }, 2500);
        }
      }
    }
  }
</script>

<style>
   /**/
</style>
